import React, { useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import "./Aboutus.css";

export default function Aboutus() {
  useEffect(() => {
    scroll.scrollTo('about-us', {
      smooth: true,
      offset: -100,
      duration: 100,
    });
  }, []);
  return (
    <section id="about-us" className="container PrivacyPolicySec py-5">
      <div className="row">
        <div className="col">
          <div className="card PrivacyPolicyCard">
            <h3 className="card-header  py-3">About us</h3>
            <div className="card-body">
              <div className="headingMain py-3 px-5">
                <h3 className="text-start text-facebook">
                  Private and Secure Online Experience with 123myvpn
                </h3>
              </div>
              <div className="px-5">
                <div className="headingMain">
                  <p className="paragraphAbout text-black fs-6">
                    At 123myvpn, we were born from a shared frustration with the
                    lack of true online privacy. With the ever-growing presence
                    of online trackers, data breaches, and government
                    surveillance, we saw a need for a robust and user-friendly
                    solution that could bypass censorship easily. We believe the
                    internet should be a free and open space where you can
                    express yourself and explore information without fear. That
                    is why we created 123myvpn, a powerful tool to empower you
                    to take back control of your online privacy and security{" "}
                  </p>
                </div>

                <ul className="list-group list-group-flush unstyled">
                  <li className="unstyled list-group-item px-0">
                    <span className="fs-4 fw-bold py-2 d-block">
                      Why Choose Our 123myvpn Services?
                    </span>
                    <ul className="mainUl">
                      <li className="fs-6 py-2 abtList">
                        <b> Unbreakable Security :</b> We utilize
                        industry-leading encryption protocols to protect your
                        data from spying eyes.
                      </li>

                      <li className="fs-6 py-2 abtList">
                        <b> Global Server Network : </b> Connect to thousands of
                        servers in numerous countries. We ensure optimal speed
                        and unrestricted access to geo-blocked content.
                      </li>
                      <li className="fs-6 py-2 abtList">
                        <b> 100% Privacy :</b> We have a strict no-logs policy
                        that guarantees your online activities and browsing
                        history are never recorded or shared.
                      </li>
                      <li className="fs-6 py-2 abtList">
                        <b> Effortless Experience :</b> Our intuitive VPN
                        application for all devices makes connecting to a secure
                        VPN server a breeze.
                      </li>
                      <li className="fs-6 py-2 abtList">
                        <b> Excellent Customer Support: </b> : Our dedicated
                        customer support team is always available to answer your
                        questions and troubleshoot any issues.
                      </li>

                      {/* Continue listing the points */}
                    </ul>
                  </li>
                  {/* Continue listing the points */}
                </ul>

                <ul className="list-group list-group-flush PrivacyPolicyList">
                  <li className="unstyled list-group-item px-0">
                    <span className="fs-4 fw-bold py-2 d-block">
                      Our Team: The Experts Behind 123myvpn
                    </span>
                    <p className="paragraphAbout text-black fs-6">
                      The 123myvpn's team is a passionate group of cybersecurity
                      experts and tech enthusiasts. We are dedicated to
                      developing the most reliable and secure VPN service
                      available. We come from diverse backgrounds, but we share
                      a common goal: to empower users with the tools they need
                      to navigate the online world with confidence.
                    </p>
                  </li>
                  {/* Continue listing the points */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Repeat the same structure for each section */}
    </section>
  );
}
